/* eslint react/forbid-prop-types:0 */

import React from 'react';
import getRecipeInfo from 'app/common/react/components/growth/unauth/pin/RichSnippet/RichPinUtil';
import PinAttributionTitle from 'app/common/react/components/growth/unauth/pin/PinAttributionTitle/PinAttributionTitle';
import PinDescription from 'app/common/react/components/growth/unauth/pin/PinDescription/PinDescription';
import PinLandingRecipeTime from 'app/common/react/components/growth/activation/PinLanding/PinLandingRecipeTime';
import PropTypes from 'prop-types';
import RichPinAttribution from 'app/common/react/components/growth/unauth/pin/PinIconAndAttribution/RichPinAttribution';
import { shouldRenderAttributionTitle } from 'app/common/react/components/growth/unauth/pin/pinUtils';

const styles = {
  wrapper: {
    width: '236px',
  },
};

export function PinMeta(props) {
  // Note: any logic that would changes the height of any part of the pin that is visible on pageload
  // should be added to methods in pinUtils.js so that it can be used to measure height of pin on server
  const {
    hideMeta = false,
    hideVaseTags = false,
    pin,
    carouselTagColor,
    disableDeeplinks,
    isPaidTraffic,
    openInCurrentTab,
    showSeeMore,
    vaseClickHandler,
    vaseCarouselStyleOverrides,
    showPinDescriptionPinPageGroup,
    secondaryFeed,
    showRichPinAttribution = false,
    handleClickSeeMore,
    inPinGridOptGroup = false,
    pinGridOptGroup = '',
  } = props;

  const renderAttributionTitle = shouldRenderAttributionTitle(pin);

  if (renderAttributionTitle || !hideMeta || showRichPinAttribution) {
    let recipe = {};
    if (showRichPinAttribution) {
      recipe = getRecipeInfo(pin).recipe;
    }

    const pinAttributionTitle = renderAttributionTitle ? (
      <PinAttributionTitle
        pin={pin}
        inPinGridOptGroup={inPinGridOptGroup}
        pinGridOptGroup={pinGridOptGroup}
      />
    ) : null;

    const richPinAttribution = showRichPinAttribution ? (
      <RichPinAttribution pin={pin} recipe={recipe} inRemoveInlineGroup={inPinGridOptGroup} />
    ) : null;
    const richRecipeAttribution =
      pin && showRichPinAttribution ? (
        <PinLandingRecipeTime recipe={recipe} iconSize={12} isInPinGrid />
      ) : null;

    const pinMetaInnerHtml = (
      <React.Fragment>
        {!inPinGridOptGroup || hideMeta ? richPinAttribution : null}
        {!inPinGridOptGroup || hideMeta ? pinAttributionTitle : null}
        {!inPinGridOptGroup || hideMeta ? richRecipeAttribution : null}
        {!hideMeta ? (
          <PinDescription
            carouselTagColor={carouselTagColor}
            disableDeeplinks={disableDeeplinks}
            isPaidTraffic={isPaidTraffic}
            pin={pin}
            hideVaseTags={hideVaseTags}
            openInCurrentTab={openInCurrentTab}
            showSeeMore={showSeeMore}
            vaseClickHandler={vaseClickHandler}
            vaseCarouselStyleOverrides={vaseCarouselStyleOverrides}
            showPinDescriptionPinPageGroup={showPinDescriptionPinPageGroup}
            secondaryFeed={secondaryFeed}
            handleClickSeeMore={handleClickSeeMore}
            richPinAttribution={richPinAttribution}
            richRecipeAttribution={richRecipeAttribution}
            inPinGridOptGroup={inPinGridOptGroup}
            pinGridOptGroup={pinGridOptGroup}
          />
        ) : null}
      </React.Fragment>
    );

    return inPinGridOptGroup ? (
      pinMetaInnerHtml
    ) : (
      <div style={styles.wrapper}>{pinMetaInnerHtml}</div>
    );
  }
  return null;
}

PinMeta.propTypes = {
  carouselTagColor: PropTypes.string,
  disableDeeplinks: PropTypes.bool,
  hideMeta: PropTypes.bool,
  isPaidTraffic: PropTypes.bool,
  inPinGridOptGroup: PropTypes.bool,
  pinGridOptGroup: PropTypes.string,
  openInCurrentTab: PropTypes.bool,
  pin: PropTypes.shape({
    id: PropTypes.string,
    aggregated_pin_data: PropTypes.object,
    attribution: PropTypes.object,
    comment_count: PropTypes.number,
    description: PropTypes.string.isRequired,
    domain: PropTypes.string.isRequired,
    pin_join: PropTypes.object,
    place_summary: PropTypes.object,
    repin_count: PropTypes.number.isRequired,
    rich_summary: PropTypes.object,
    rich_metadata: PropTypes.object,
  }),
  secondaryFeed: PropTypes.bool,
  showRichPinAttribution: PropTypes.bool,
  showSeeMore: PropTypes.bool,
  vaseClickHandler: PropTypes.func.isRequired,
  vaseCarouselStyleOverrides: PropTypes.shape({}),
  showPinDescriptionPinPageGroup: PropTypes.string,
  handleClickSeeMore: PropTypes.func,
};

export default PinMeta;
